import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thanking-you-for-shopping',
  templateUrl: './thanking-you-for-shopping.component.html',
  styleUrls: ['./thanking-you-for-shopping.component.scss']
})
export class ThankingYouForShoppingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
